import React from 'react';

import { Tooltip } from 'primereact/tooltip';

import { TimelineGroup } from './types';

export interface BuildGroupsArgs {
  calendarAssignment: {
    employees?: { id: number; name?: string; personnelNumber?: string }[];
  } | null;
  employeesTotalTimesheet: Record<string, number>;
  showTotalColumn: boolean;
  sidebarWidth: number;
  sidebarInfoWidth: number;
  totalColumnWidth: number;
  DEPARTMENT_SCHEDULE_GROUP_ID: number;
  copyToClipboard: (text: string, message: string) => void;
}

export function buildGroups({
  calendarAssignment,
  employeesTotalTimesheet,
  showTotalColumn,
  sidebarWidth,
  sidebarInfoWidth,
  totalColumnWidth,
  DEPARTMENT_SCHEDULE_GROUP_ID,
  copyToClipboard
}: BuildGroupsArgs): TimelineGroup[] {
  const groupsList: TimelineGroup[] = [
    {
      id: DEPARTMENT_SCHEDULE_GROUP_ID,
      title: (
        <div
          className="department-schedule-group"
          style={{ width: sidebarWidth, display: 'flex', alignItems: 'center' }}
        >
          <div
            style={{ flex: 1, minWidth: sidebarInfoWidth, padding: '4px 8px' }}
          >
            <span className="label">График работы участка:</span>
          </div>
        </div>
      )
    }
  ];

  if (calendarAssignment?.employees) {
    calendarAssignment.employees.forEach((emp) => {
      const totalHours = employeesTotalTimesheet[emp.id.toString()] || 0;
      groupsList.push({
        id: emp.id,
        title: (
          <div
            className="employee-group-title"
            style={{
              width: sidebarWidth,
              display: 'flex',
              alignItems: 'center',
              padding: '4px 8px',
              borderBottom: '1px solid #e0e0e0'
            }}
          >
            <Tooltip
              target=".group-title-tooltip-val"
              className="calendar-assignments-group-title-tooltip"
              position="bottom"
            />
            <div
              className="info-container"
              style={{ flex: 1, minWidth: sidebarInfoWidth }}
            >
              <div className="text-container">
                <span className="label">ФИО: </span>
                <i
                  className="pi pi-copy ml-2 copy-icon cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    copyToClipboard(emp.name || '', 'ФИО скопировано');
                  }}
                />
                <span
                  className="value font-medium group-title-tooltip-val"
                  data-pr-tooltip={emp.name}
                >
                  {emp.name || '-'}
                </span>
              </div>
              <div className="text-container">
                <span className="label">Таб. №: </span>
                <i
                  className="pi pi-copy ml-2 copy-icon cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    copyToClipboard(
                      emp.personnelNumber || '',
                      'Табельный номер скопирован'
                    );
                  }}
                />
                <span
                  className="value font-medium group-title-tooltip-val"
                  data-pr-tooltip={emp.personnelNumber}
                >
                  {emp.personnelNumber || '-'}
                </span>
              </div>
            </div>
            {showTotalColumn && (
              <div
                className="total-container"
                style={{
                  width: totalColumnWidth,
                  fontWeight: 'bold',
                  backgroundColor: '#e0e0e0'
                }}
              >
                {totalHours.toFixed(1)}
              </div>
            )}
          </div>
        )
      });
    });
  }

  return groupsList;
}
